function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { BOS, HALIFAX, LLOYDS, MBNA, SCOTTISH_WIDOWS } from "../../constants";
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4.792",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4.792",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
HalifaxIcon.defaultProps = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4.792",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
LloydsIcon.defaultProps = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4.792",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
MbnaIcon.defaultProps = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4.792",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useTheme } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme() || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.bullet) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.bullet;
  } else {
    switch (brand) {
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      default:
        svg = LloydsIcon;
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}